import React from 'react'

export interface IconProps {
  size?: number | string
  className?: string
  strokeWidth?: number
  color?: string
  children: React.ReactNode
}

export function Icon({ 
  size = 24, 
  className = '', 
  strokeWidth = 2, 
  color = 'currentColor',
  children 
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {children}
    </svg>
  )
}
